import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2'

import sellerImg from '../img/seller-signup.jpg';
import '../styles/signup.css'

export default class SignUpSeller extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChange(event) {
        let values = this.state;
        // console.log('values: ',values);
        // console.log(event.target.name);
        values[event.target.name] = event.target.value;
        this.setState(values);
        // console.log(values, this.state);
    }

    handleSignup(){
        axios.post('https://spice-api.pearlfall.vercel.app'+`/users/signup/seller`, this.state)
            .then(function (response) {
                console.log('response', response);
                if(response.data.status === 'Success'){
                    Swal.fire({
                        title: 'Success!',
                        text: 'Successfully created',
                        type: 'success',
                        confirmButtonText: 'Next'
                    })
                        .then(()=>{
                            console.log("Dismissed");
                            window.location.assign('/signin')

                        })
                }else if(response.data.status === "Existed"){
                    Swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        type: 'error',
                        confirmButtonText: 'Cool'
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    render() {
        return (
            <React.Fragment>
                <div className="signup-bg">
                    <div className="left">
                        <h1 className="text-center title">Seller Sign Up</h1>
                        <div className="bg-image">
                            <div className="bg-text" >
                                <Container fluid = {true}>
                                    {/*<h1 className="text-center title">Seller Sign Up</h1>*/}
                                    <Form>
                                        {/*{this.state && // these three line is ignored on first render. They show letters your types before form*/}
                                        {/*<p>{this.state.title}</p>*/}
                                        {/*}*/}
                                        <FormGroup>
                                            <Label for="name">Name</Label>
                                            <Input type="text" name="name" id="name" placeholder="Name"
                                                   onChange={this.handleChange.bind(this)}/>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="username">Username</Label>
                                            <Input type="text" name="username" id="username" placeholder="Username"
                                                   onChange={this.handleChange.bind(this)}/>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="exampleEmail">Email</Label>
                                            <Input type="email" name="email" id="exampleEmail" placeholder="Email"
                                                   onChange={this.handleChange.bind(this)}/>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="examplePassword">Password</Label>
                                            <Input type="password" name="password" id="examplePassword" placeholder="Password"
                                                   onChange={this.handleChange.bind(this)}/>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="topic">Topic</Label>
                                            <Input type="select" name="topic" id="topic" onChange={this.handleChange.bind(this)}>
                                                <option>---Select---</option>
                                                <option>Sports</option>
                                                <option>Arts</option>
                                                <option>Travel</option>
                                                <option>Music</option>
                                                <option>Coding</option>
                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="region">Region</Label>
                                            <Input type="select" name="region" id="region" onChange={this.handleChange.bind(this)}>
                                                <option>---Select---</option>
                                                <option>San Francisco</option>
                                                <option>San Jose</option>
                                                <option>Cupertino</option>
                                                <option>Redwood City</option>
                                                <option>Mountain View</option>
                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="exampleText">Description</Label>
                                            <Input type="textarea" name="description" id="description" placeholder="What talent do you want to share? Explain yourself!" onChange={this.handleChange.bind(this)} />
                                        </FormGroup>
                                        <Button onClick={this.handleSignup.bind(this)} className="submitbtn">Submit</Button>
                                    </Form>
                                </Container>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                    </div>
                </div>

            </React.Fragment>

        );
    }
}
